import { GridColDef } from "@mui/x-data-grid";
import { Button } from "@mui/material";
import ConfirmActionButton from "../../../components/Fleet/ConfirmActionButton/ConfirmActionButton";
import UpdateAccidentPopup from "../../../components/Fleet/Accident/UpdateAccidentPopup/UpdateAccidentPopup";
import NotesButton from "../../../components/Fleet/Accident/NotesButton/NotesButton";
import { formatDateTimeInChicago } from "../../../helpers/formatingFunctions";
import dayjs from "../../../utils/dayjsTimezone";

export function getAccidentsTableColumns(
  openUploadModal: (row: any) => void,
  openPreviewModal: (row: any) => void
): GridColDef[] {
  return [
    {
      field: "update",
      headerName: "Update",
      width: 150,
      sortable: false,
      renderCell: (params) => {
        return <UpdateAccidentPopup accident={params.row} />;
      },
    },
    {
      field: "notes",
      headerName: "Notes",
      width: 100,
      sortable: false,
      renderCell: (params) => <NotesButton accidentId={params.row.id} />,
    },

    {
      field: "actions",
      headerName: "Actions",
      width: 250,
      sortable: false,
      renderCell: (params) => {
        const row = params.row;
        return (
          <>
            <Button
              variant="contained"
              size="small"
              onClick={() => openUploadModal(row)}
            >
              Upload Files
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={() => openPreviewModal(row)}
              style={{ marginLeft: 8 }}
            >
              Preview Files
            </Button>
          </>
        );
      },
    },
    {
      field: "date",
      headerName: "Date & Time",
      width: 210,
      type: "dateTime",
      valueFormatter: (params) => formatDateTimeInChicago(params),
      sortComparator: (value1, value2) => {
        const date1 = dayjs(value1 as string);
        const date2 = dayjs(value2 as string);

        if (!date1.isValid() && !date2.isValid()) return 0;
        if (!date1.isValid()) return -1;
        if (!date2.isValid()) return 1;

        return date1.valueOf() - date2.valueOf();
      },
    },
    {
      field: "ownerCompanyName",
      headerName: "Company",
      width: 200,
    },
    { field: "driverName", headerName: "Driver", width: 200 },
    { field: "typeOfIncident", headerName: "Type of Incident", width: 200 },
    { field: "description", headerName: "Description", width: 300 },
    { field: "location", headerName: "Location", width: 200 },
    { field: "status", headerName: "Status", width: 150 },
    { field: "truckUnitNumber", headerName: "Truck", width: 150 },
    { field: "trailerNumber", headerName: "Trailer", width: 150 },
    { field: "dispatcherName", headerName: "Dispatcher", width: 200 },
    { field: "claimNumber", headerName: "Claim Number", width: 150 },
    {
      field: "claimAmount",
      headerName: "Claim Amount",
      width: 150,
      type: "number",
      valueFormatter: (params) =>
        params != null ? `$${Number(params).toFixed(2)}` : "",
    },
    {
      field: "isDriverAtFault",
      headerName: "Driver at Fault",
      width: 150,
      type: "boolean",
    },
    { field: "insurance", headerName: "Insurance", width: 200 },
    { field: "broker", headerName: "Broker", width: 200 },
    { field: "adjuster", headerName: "Adjuster", width: 200 },
    {
      field: "areWePaid",
      headerName: "Are We Paid",
      width: 150,
      type: "boolean",
    },
    {
      field: "paidByCompany",
      headerName: "Company loss",
      width: 150,
      type: "number",
      valueFormatter: (params) =>
        params != null ? `$${Number(params).toFixed(2)}` : "",
    },
    {
      field: "paidByCompanyInsurance",
      headerName: "Paid by Company Insurance",
      width: 200,
      type: "number",
      valueFormatter: (params) =>
        params != null ? `$${Number(params).toFixed(2)}` : "",
    },
    {
      field: "paidByOtherPartyInsurance",
      headerName: "Paid by Other Party Insurance",
      width: 200,
      type: "number",
      valueFormatter: (params) =>
        params != null ? `$${Number(params).toFixed(2)}` : "",
    },
    {
      field: "paidByOtherParty",
      headerName: "Paid by Other Party",
      width: 200,
      type: "number",
      valueFormatter: (params) =>
        params != null ? `$${Number(params).toFixed(2)}` : "",
    },
    {
      field: "deductionFromDriver",
      headerName: "Deduction from Driver",
      width: 200,
      type: "number",
      valueFormatter: (params) =>
        params != null ? `$${Number(params).toFixed(2)}` : "",
    },
    {
      field: "hasCitation",
      headerName: "Has Citation",
      width: 150,
      type: "boolean",
    },
    {
      field: "hasTowing",
      headerName: "Has Towing",
      width: 150,
      type: "boolean",
    },
    {
      field: "towingAmount",
      headerName: "Towing Amount",
      width: 150,
      type: "number",
    },
    {
      field: "hasInjury",
      headerName: "Has Injury",
      width: 150,
      type: "boolean",
    },
    {
      field: "hasDrugTest",
      headerName: "Has Drug Test",
      width: 150,
      type: "boolean",
    },
    {
      field: "hasPoliceReport",
      headerName: "Has Police Report",
      width: 150,
      type: "boolean",
    },
    {
      field: "hasTotalLoss",
      headerName: "Has Total Loss",
      width: 150,
      type: "boolean",
    },

    {
      field: "Delete",
      headerName: "Delete",
      width: 250,
      sortable: false,
      renderCell: (params) => {
        return (
          <ConfirmActionButton
            id={params.row.id}
            entityType="Accident"
            actionType="delete"
            entityLabel="Accident"
            queryKey="accidents"
            buttonLabel="Delete"
            buttonColor="error"
          />
        );
      },
    },
  ];
}
